export const MuiTextField = {
  defaultProps: {
    fullWidth: true,
  },
  styleOverrides: {
    root: {
      backgroundColor: '#fff',

      '& input[type="date"]::-webkit-calendar-picker-indicator, & input[type="time"]::-webkit-calendar-picker-indicator':
        {
          display: 'none',
          WebkitAppearance: 'none',
        },
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
};
